
import { createAsyncThunk } from "@reduxjs/toolkit";
import service from "../services/service";
import claim_service, { UpdateClaimStatusbulk } from '../services/claim_service';
import { getStorage } from "../../../utilities/browserStorage";
import service1 from '../../customerSetup/providerManagement/service';
import service3 from '../../dictionaries/revenueCode/service';
import searchClaimService from '../services/claim_service'
import chargePanelService from "../../dictionaries/ChargePanels/service";
import { buildClaimsPayload, claimFormWaringMessage, createSaveData, fetchFeeRequestDataFormatter, handleIdentifierErrors, processAmbulanceClaimPayload, setWarningFromServer } from "./claimDataGenerator";
import { resetArnotes, saveClaimIDWaringPopUP, setFormWaringData, setFormWarningMessages, showModalWindow, showNotifications } from "./ClaimModuleSlice";
import { APIErrorHandler, claimValidation } from "./claimAlertValidations";
import { ACTIVE_TYPES, DEFAULT_PAGING_SIZE } from "../../../utilities/staticConfigs";
import { ADD_SUCCESS, UPDATE_SUCCESS } from "../../../utilities/labelConfigs";
import i18n from "../../../utilities/i18n";
import { format } from "date-fns";


/**
 * @description Get the list of tabs opened by the session user and if not any opened then direct to last10 tab by default
 * @param None
 */
export const getUserOpenedClaimModuleTabs = createAsyncThunk(
    'claims/getUserOpenedClaimModuleTabs',
    async (payload, { rejectWithValue }) => {
        try {
            return await service.GetSelectedTabs("claims", getStorage("practice"));
        } catch (error) {
            return rejectWithValue("Error while fetching opened parent claim opened tabs.");
        }
    }
);

/**
* @description get last 10 table data 
 * @param query
 */
export const getlast10TableData = createAsyncThunk(
    'claims/last10TableData',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await service.GetListPatientClaims(payload);
            return response.data
        } catch (error) {
            return rejectWithValue("Error while fetching last10 claim list.");
        }
    }
);

/**
 * @description get last 10 table data 
 * @param query
 */
export const getSearchClaimsTableData = createAsyncThunk(
    'claims/searchClaimsTableData',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await service.GetListPatientClaims(payload.query);
            if (response?.data?.error_message)
                return rejectWithValue({ error_message: response?.data?.error_message ?? "An un-expected error occurred while fetching the data." });
            return { data: response.data, isSearch: payload.search }
        } catch (error) {
            return rejectWithValue("Error while fetching claim list.");
        }
    }
)

/**
 * @description Function to open new claim parent tab like last10, search, claimPk
 * @param String enum pk= last10 || search || claimPk
 * @param String claimId
 * @param String enum action= "add" || "remove"
 */
export const addRemoveFromSelectedTab = createAsyncThunk(
    'claims/addRemoveFromSelectedTab',
    async (payload, { rejectWithValue }) => {
        try {
            let request = {
                "pk": payload.item.pk,
                "claim_id": payload.item.claimId || payload.item.claim_id || "",
                "type": payload.item.type,
                "action": payload.item.action,
                "practice_pk": getStorage('practice'),
            }

            if (payload.item.isClosed) {
                request = {
                    ...request,
                    isClosed:true
                }
            }

            if (payload.item.active_tab) {
                request = {
                    ...request,
                    active_tab: payload.item.active_tab
                } 
            }
            const response = await service.AddRemoveSelectedTab(request);
            if (response?.data?.status === "success") {
                return { payload: request, tab: payload.tab }
            }
            return rejectWithValue(response?.data?.message);
        } catch (error) {
            return rejectWithValue("Error while requesting to open parent claim tab.");
        }
    }
)

/**
 * @description Function to open new claim parent tab like last10, search, claimPk
 * @param String enum pk= last10 || search || claimPk
 * @param String claimId
 * @param String enum action= "add" || "remove"
 */
export const addActiveSubTab = createAsyncThunk(
    'claims/addActiveSubTab',
    async (payload, { rejectWithValue }) => {
        try {
            let request = {
                "pk": payload.payload.pk,
                "claim_id": payload.payload.claimId ? payload.payload.claimId : "",
                "type": payload.payload.type,
                "action": payload.payload.action,
                "practice_pk": getStorage('practice'),
                "active_tab": payload.payload.active_tab
            }
            const response = await service.AddRemoveSelectedTab(request);
            if (response?.data?.status === "success") {
                return { payload: request }
            }
        } catch (error) {
            return rejectWithValue("Error while requesting to  open parent claim tab.");
        }
    }
)

/**
 * @description api is used to call all details of existing claim such as service line, billing info,additional info
 * @params String claimPK 
 */
export const getEditDetails = createAsyncThunk(
    'claims/getEditDetails',
    async (payload, thunkAPI) => {
        try {
            let claimInfo = await service.GetGeneralClaim(payload).then(response => {
                if (response.data) {
                    return response.data;
                }
                else{
                    if (response.error_data) {
                        throw new Error(response.error_data.error_message)
                    }
                }
            });
            let billingInfoPk = claimInfo?.pks?.billing_info_pk;
            let additionalClaimInfoPk = claimInfo?.pks?.additional_claim_info_pk;
            let serviceLinesPk = claimInfo?.pks?.diagnosises_pk

            let [billingInfo, procedureInfo, additionalInfo,responsibilityType] = await Promise.all([
                service.GetBillingInfoClaim(billingInfoPk).then(response => {
                    if (response.data) {
                        return response.data;
                    }else {
                        throw new Error(response?.error_data?.error_message ?? "An un-expected error occurred")
                    }
                }),
                service.GetServiceLineClaim(serviceLinesPk).then(response => {
                    if (response.data) {
                        return response.data;
                    }else {
                        throw new Error(response?.error_data?.error_message ?? "An un-expected error occurred")
                    }
                }),
                service.GetAdditionalClaim(additionalClaimInfoPk).then(response => {
                    if (response.data) {
                        return response.data;
                    }else {
                        throw new Error(response?.error_data?.error_message ?? "An un-expected error occurred")
                    }
                }),
                service.GetResponsibilityType(claimInfo?.patient ? claimInfo?.patient : "").then(response=>{
                    if(response.data){
                        return response.data.responsibility_list
                    }else {
                        throw new Error(response?.error_data?.error_message ?? "An un-expected error occurred")
                    }
                }),
            ]);

            if(claimInfo?.authorization_referral){
                let patient = claimInfo?.patient;
                let provider =
                claimInfo?.authorization_referral === 1
                        ? billingInfo?.billing_provider
                        : billingInfo?.referring_provider;
                setTimeout(() => {
                    thunkAPI.dispatch(
                        fetchIdentifiers({
                            patient: patient,
                            auth: claimInfo?.authorization_referral,
                            provider: provider ? provider : "",
                            claimPK: claimInfo?.id
                        })
                    );
                }, 250);
            }
            return {
                claimInfo,
                billingInfo,
                procedureInfo,
                additionalInfo,
                responsibilityType,
                payload
            };
        } catch (error) {
            /**
             * if any api get an error response it will close the claim tab automatically
             */
            const state = thunkAPI.getState();
            let { claimManagement } = state;
            let openedCliamDetails = claimManagement?.claimParentTabs?.find((item) => item.pk == payload);
            if (openedCliamDetails) {
                let item = {
                    pk: openedCliamDetails?.pk, claimId: openedCliamDetails?.claim_id,
                    type: 'claims', action: 'remove'
                }
                thunkAPI.dispatch(addRemoveFromSelectedTab({ item: item, tab: 'editClaims' + openedCliamDetails?.pk }));
            }
            return thunkAPI.rejectWithValue('Error fetching claim information:' + error.message);
        }
    }
)



//getting patient details on patient pk of selected patients
export const getPatientDetails = createAsyncThunk(
    "claim-info/patient-pk-details", async (payload, thunkAPI) => {
        try {
        const promises = [
            await service.GetPatientDetails(payload.patient_pk).then(response => {
                if (response.data) {
                    return response.data
                }else {
                    throw new Error(response?.error_data?.error_message ?? "An un-expected error occurred")
                }
            }),
            await service.GetPatientDXCPTDetails(payload.patient_pk).then(response => {
                if (response.data) {
                    return response.data
                }else {
                    throw new Error(response?.error_data?.error_message ?? "An un-expected error occurred")
                }
            }),
            await service.GetPatientAccidentInfo(payload.patient_pk).then(response => {
                if (response.data) {
                    return response.data
                }else {
                    throw new Error(response?.error_data?.error_message ?? "An un-expected error occurred")
                }
            }),
            await service.GetPracticeBasicData(getStorage('practice')).then(response => {
                if (response.data) {
                    return response.data
                }else {
                    throw new Error(response?.error_data?.error_message ?? "An un-expected error occurred")
                }
            }),
            await service.ListAccidentTypes(DEFAULT_PAGING_SIZE, 0, payload.claim_pk ? payload.claim_pk : "").then(response => {
                if (response.data) {
                    return response.data
                }else {
                    throw new Error(response?.error_data?.error_message ?? "An un-expected error occurred")
                }
            }),

            /**
             * getting responsibility type for the patient 
            */

            await service.GetResponsibilityType(payload.patient_pk ? payload.patient_pk : "").then(response=>{
                if(response.data){
                    const responsibilityList = response?.data?.responsibility_list ?? [];
                    return responsibilityList
                }else {
                    throw new Error(response?.error_data?.error_message ?? "An un-expected error occurred")
                }
            }),
        ]

            const [
                billingData,
                serviceData,
                additionalData,
                practiceData,
                accidentList,
                responsibilityType,
            ] = await Promise.all(promises);

            return {
                billingData,
                serviceData,
                additionalData,
                practiceData,
                accidentList,
                responsibilityType,
            };

        } catch (error) {
            return thunkAPI.rejectWithValue('Error fetching claim information:' + error.message)
        }
    }
)

/**
 * if there is no pos against the cpt it will take service location list cpt
 */
export const GetServiceLocationPOSList = createAsyncThunk(
    "claim-info/servicelocationpos", async (payload) => {
        const result = await service.GetFacilityPos(payload);
        if (result) {
            return result.data
        }
    }
)

export const GetCPTCodeListWithDate = createAsyncThunk(
    "claim-info/getcptcodelistwithdate", async (payload) => {
        let practicePK = getStorage('practice');
        let result;
        if(!payload.isAdvanceEnabled && payload.query){
            result = await service.GetCPTCodeList(0, 0, practicePK, payload.type, payload.query, payload.claimPK, payload.dos);
        }else{
            result={data:[]}
        }
        return { data: result.data, request: payload };
    }
)

export const fetchIdentifiers = createAsyncThunk(
    'yourSlice/fetchIdentifiers',
    async ({ patient, auth, provider,claimPK }, { rejectWithValue }) => {
        try {
            const response = await service.GetIdentifiers(patient, auth, provider,claimPK);
            if (response.data) {
                return {data:response.data,claimPK:claimPK};
            }
            if (response.error_data) {
                const { message } = handleIdentifierErrors(response.error_data);
                return rejectWithValue({msg:message});
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);


export const fetchUnAppliedFee = createAsyncThunk(
    "claim-info/fetch-unapplied_fee", async (payload,{ getState,rejectWithValue }) => {
    let {type,id,claimPK}=payload;
    const state = getState();
    let {claimManagement}=state
    let {billingInfoDetails,serviceLineDetails,additionalClaimDetails}=claimManagement;
    const requestData=await fetchFeeRequestDataFormatter(billingInfoDetails,serviceLineDetails,additionalClaimDetails,type,id)
    try{
        const result=await claim_service.FetchFeeDetails(requestData);
        if(result.data && result.status==200){
            return {data:result.data,payload,claimPK:claimPK,type:type};
        }else(result.status==400)
        {
             return rejectWithValue( "An un-expected error occurred");
        }
    }catch(error){
        return rejectWithValue(error)
    }
  }
)

/**
 * function to call save and update claim
 */

export const createAndUpdateClaim = createAsyncThunk(
    "claim-info/createAndUpdateClaim", async (payload, { dispatch, getState,rejectWithValue }) => {
        const state = getState();
        let { claimManagement, claimSelectInputManager } = state;
        const enable_advance_fee_schedule=getStorage('enable_advance_fee_schedule');
        let {all,single}=claimManagement.fee_field_status;
        let { claimPK, isClose } = payload;
        let { isError, errorMessage, status } = claimValidation(claimManagement, claimSelectInputManager)
        const shouldShowFeeConfirmation = all || single;
        // checks if Transport Code equals 2 i.e, Return trip and if return trip reason is empty, immediately returns without saving.
        if (claimManagement.additionalClaimDetails?.transport_code == 2 && !claimManagement.additionalClaimDetails?.return_trip_reason){
            return;
        }

        if(shouldShowFeeConfirmation && enable_advance_fee_schedule=="true"){
            return rejectWithValue({type:"fee_confirmation_modal",value:true})
        }


        if (isError) {
            dispatch(showNotifications({ isopen: isError, message: errorMessage, status: status }))
        }
        else {

            const additionalClaimInfoPayload = processAmbulanceClaimPayload(
                claimManagement.additionalClaimDetails
            );

            let {
                professionaldata,
                billingData,
                diagnosisdata,
                procedureArray,
                additionaldata,
            } = createSaveData(
                claimManagement.professionalClaimDetails,
                claimManagement.billingInfoDetails,
                claimManagement.serviceLineDetails,
                additionalClaimInfoPayload,
                claimPK
            );

            let result = "";


            let data = {
                ...professionaldata,
                billing_info: {
                    ...billingData,
                    billing_provider_id: billingData.billing_provider_id ?? null,
                    rendering_provider_id: billingData.rendering_provider_id ?? null,
                    supervising_provider_id: billingData.supervising_provider_id ?? null,
                    ordering_provider_id: billingData.ordering_provider_id ?? null,
                    referring_provider_id: billingData.referring_provider_id ?? null
                },
                diagnosises: diagnosisdata,
                additional_claim_info: additionaldata,
                procedures: procedureArray,
            };

            if (!claimPK) {
                result = await service.SaveNewClaimCopy(data);
            } else {
                result = await service.UpdateNewClaim(claimPK, data);
            }

            let isNewClaim = false;
            let claim_id = ""
            let claim_pk = ""
            if (result.status === 201 || result.status === 200) {
                if (result.status === 201) {
                    dispatch(showNotifications({ isopen: true, message: ADD_SUCCESS, status: "success" }))
                    isNewClaim = true;
                }
                else {
                    dispatch(showNotifications({ isopen: true, message: UPDATE_SUCCESS, status: "success" }))
                    /**
                     * calling all API to restore claim details 
                     */
                    if(claimPK && !isClose){
                    dispatch(getEditDetails(claimPK));
                    }

                    /**
                     * Claim in-active logics:
                     * When a claim is being in-activated, then immediately close that specific claim tab.
                     * Also remove the html focus element from the in-active button
                     * Finally return from this asyncThunk api function i.e createAndUpdateClaim
                     */
                    if (!professionaldata?.active) {
                        // Allowing 2 seconds of await before closing the tab, so user can read the success notify message before claim tab is being closed
                        await new Promise(resolve => setTimeout(resolve, 2000));
                        dispatch(showModalWindow({ key: "inactiveClaimModal", value: false, claimPK: "" }));
                        let item = {
                            pk: claimPK, claim_id: result.data?.custom_claim_id,
                            type: 'claims', action: 'remove',
                        }
                        dispatch(addRemoveFromSelectedTab({ item: item, tab: item.pk !== "add_new" ? "editClaims" + item.pk : "editClaim" }))
                        document.activeElement?.blur();
                        return;
                    }
                }

                /**waring text handled here */
                // eslint-disable-next-line
                let waringText = claimFormWaringMessage(result.data);
                let serverWarings = setWarningFromServer(result.data);
                if (serverWarings) {
                    dispatch(setFormWaringData(serverWarings));
                }
                if (waringText) {
                    /*** show formwarning on save if warning Text contain error*/
                    dispatch(setFormWarningMessages(waringText));
                    if (isClose) {
                        claim_pk = result.data.id;
                        claim_id = result.data.custom_claim_id;
                        dispatch(showModalWindow({ key: "saveCloseConfirmation", value: true }));
                        dispatch(saveClaimIDWaringPopUP({claimPK:claim_pk,claimId:claim_id,isClose:isClose,isSave:isNewClaim}))
                    }
                    else {
                        claim_pk = result.data.id;
                        claim_id = result.data.custom_claim_id;
                        dispatch(showModalWindow({ key: "saveConfirmation", value: true }));
                        dispatch(saveClaimIDWaringPopUP({ claimPK: claim_pk, claimId: claim_id, isClose: isClose, isSave: isNewClaim }))
                    }
                } else if (isClose) {
                    if (result.data) {
                        claim_pk = result.data.id;
                        claim_id = result.data.custom_claim_id;
                    }

                    let item1 = {}
                    let item2 = {};
                    if (isNewClaim) {
                        item1 = {
                            pk: claim_pk, claimId: claim_id, type: 'claims',
                            action: 'add', isClosed: true,
                            practice_pk: getStorage("practice")
                        }
                        item2 = {
                            pk: 'add_new', claimId: 'add_new',
                            type: 'claims', action: 'remove', practice_pk: getStorage("practice")
                        }

                        await dispatch(addRemoveFromSelectedTab({ item: item1, tab: item1.pk !== "add_new" ? "editClaims" + item1.pk : "editClaim" })).then(async(response)=>{
                            if(response?.meta?.requestStatus==="fulfilled"){
                                await dispatch(addRemoveFromSelectedTab({ item: item2, tab: item2.pk !== "add_new" ? "editClaims" + item2.pk : "editClaim" }))  
                            }
                        })
                    }
                    else {
                        let item = {
                            pk: claim_pk, claim_id: claim_id,
                            type: 'claims', action: 'remove',
                        }
                        dispatch(addRemoveFromSelectedTab({ item: item, tab: item.pk !== "add_new" ? "editClaims" + item.pk : "editClaim" }))
                    }
                } else {
                    if (result.data) {
                        claim_pk = result.data.id;
                        claim_id = result.data.custom_claim_id;
                    }

                    if (isNewClaim) {
                        let item1 = {
                            pk: 'add_new', claimId: 'add_new',
                            type: 'claims', action: 'remove'
                        }
                        let item2 = {
                            pk: claim_pk, claimId: claim_id,
                            type: 'claims', action: 'add',
                            active_tab: claimManagement.activeSubTab
                        }
                        await dispatch(addRemoveFromSelectedTab({ item: item1, tab: item1.pk !== "add_new" ? "editClaims" + item1.pk : "editClaim" })).then(async(response)=>{
                            if(response?.meta?.requestStatus==="fulfilled"){
                                await dispatch(addRemoveFromSelectedTab({ item: item2, tab: item2.pk !== "add_new" ? "editClaims" + item2.pk : "editClaim" }))  
                            }
                        })
                    }
                }

            } else {
                let { errorMessage, inActiveModal } = APIErrorHandler(result);
                /**show inactiveModal if claim is already inactive */
                dispatch(showModalWindow({ key: "inactiveClaimModal", value: inActiveModal }));
                dispatch(showNotifications({ isopen: true, message: errorMessage, statusTag: "error" }))
            }
        }
    }
)

export const ActivateInactiveClaim = createAsyncThunk(
    "claim-info/ActivateInactiveClaim", async (payload, { dispatch, rejectWithValue }) => {
        let data = { 'active': true}
        const result = await service.UpdateClaimActive(payload, data);
        if (result.data) {
            dispatch(showModalWindow({ key: "activeClaimModal", value: false, claimPK: payload }))
            return {
                status: "success",
                claimPK: payload
            }
        } else {
            return rejectWithValue("An error occurred while activating the claim.");
        }
    }
)


export const getPatientHistory = createAsyncThunk(
    "claim-info/patientHistory", async (payload) => {
        const result = await service.GetPatientHistory(payload);
        return result.data;
    }
)

// api for add diagnosis code using paste
export const getDiagnosisCodeOnPaste = createAsyncThunk(
    "claim-info/getDiagnosisCodeOnPaste", async (payload) => {
        let { value, type, claimPK } = payload;
        const result = await service.GetICD10List(0, 0, getStorage('practice'), type, value, claimPK);
        return { result: result.data, request: payload };
  }
)


/**
 * GET LIST OF CHARGE PANELS FOR THE CURRENT PRACTICE
 * @async
 */
export const getChargePanelsList = createAsyncThunk(
    "claim-info/getChargePanelsList",
    async (_, { rejectWithValue }) => {
        try {
            const result = await chargePanelService.ListChargePanels({
                practice_pk: getStorage('practice'),
                page: 0,
                page_size: null,
                status: ACTIVE_TYPES.find(({ name }) => name === "Active")?.id,
            });

            if (Array.isArray(result.data)) {
                return result;
            } else {
                return rejectWithValue("An error occurred while retrieving the Panels List or Invalid response format received.");
            }
        } catch (error) {
            return rejectWithValue(error.message || "An error occurred while fetching charge panels.");
        }
    }
);



/**
 * GET PROCEDURES OF A CHARGE PANEL
 * @param {Number} chargePanelId
 * @async
 */
export const addNewProcedureFromChargePanel = createAsyncThunk(
    "claim-info/addNewProcedureFromChargePanel",
    async (chargePanelId, { rejectWithValue }) => {
        try {
            const response = await chargePanelService.GetPanelProceduresList(chargePanelId);

            if (response.status != 200 || !Array.isArray(response.data)) {
                return rejectWithValue("An error occurred while retrieving the Panel Procedures.");
            } else {
                return response
            }
        } catch (error) {
            return rejectWithValue(error.message || "An error occurred while fetching Panel Procedures.");
        }
    }
);

/*
 * Function getDropDownListData fetches all the drop-down-data required for the page in one shot using promise chaining 
 */
export const getDropDownListData = createAsyncThunk(
    "arClaims/getDropDownListData",
    async (payload, thunkAPI) => {
        const pageSize = 0;
        const page = 0;
        const practicePK = getStorage('practice');
        const type = 'dropdown';
        /**
         * The promises array contains the promises returned by each API call, 
         * which can be resolved using Promise.all(promises) to wait for all the requests to complete.
         */
        const promises = [
            claim_service.ListClaimStatus(pageSize, page, practicePK, type).then(response => response.data),
            service1.getProvidersData(pageSize, page, practicePK, true).then(response => response.data),
            service.ServiceLocationLists(practicePK, null, null, true).then(response => {
                let locations = []
                response.data.map((item) => {
                    item.id = item.Id + '||' + item.location_type
                    locations.push(item)
                })
                return locations
            }),
            service.ARStatusNoteList(0, 0, practicePK).then(response => {
                let data = []
                response.data.map((item) => {
                    data.push({
                        id: item.id,
                        name: item.name
                    })
                })
                return data
            }),
            service.ARActionNoteList(0, 0, practicePK).then(response => {
                let data = []
                response.data.map((item) => {
                    data.push({
                        id: item.id,
                        name: item.name,
                        follow_up_days_count: item.follow_up_days_count
                    })
                })
                return data
            }),
            service3.GetListRevenueCode(pageSize, page).then(response => response.data),
            claim_service.ListInsuranceNames(pageSize, 0, practicePK).then(response => response.data),
            claim_service.ListCPTCodes(practicePK).then(response => response.data)
        ];
        try {
            const [
                claimStatusList,
                providerList,
                serviceLocationList,
                arStatusList,
                arActionCodeList,
                revenueCodeList,
                payerList,
                cptCodesList
            ] = await Promise.all(promises);

            return {
                claimStatusList,
                providerList,
                serviceLocationList,
                arStatusList,
                arActionCodeList,
                revenueCodeList,
                payerList,
                cptCodesList
            };
        } catch (error) {
            return thunkAPI.rejectWithValue({ errorMessage: 'Error getting Drop-down list data!' })
        }
    }
);

/**
 * get patient ledger details
 */
export const getPatientLedgerList = createAsyncThunk(
    "arClaims/getPatientLedgerList",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await service.GetPatientLederList(payload);
            if (res.data) {
                return { data: res.data };
            } else {
                return rejectWithValue({ errorMessage: 'Error getting patient ledger list!' })
            }
        } catch (error) {
            return rejectWithValue({ errorMessage: 'Error getting patient ledger list!' })
        }
    }
);

/**
 * API Call functionality to save ar-notes. 
 */
export const ARClaimNotes = createAsyncThunk(
    "claimManagement/ARClaimNotes",
    async (payload, {rejectWithValue,getState,dispatch}) => {

        try {
            let {claimManagement}=getState();
            let {arNotes,claimPK}=claimManagement;

            // Unified Validation
            if (!arNotes?.notes) {
                return rejectWithValue({ message: i18n.t("errorMessages.noteRequired") });
            }
            if (!arNotes?.ar_status_code || !arNotes?.ar_action_code) {
                return rejectWithValue({ message: i18n.t("errorMessages.mandatoryFieldsRequired") });
            }

            if (!arNotes.next_followup_date || arNotes.next_followup_date === 'Invalid Date') {
                return rejectWithValue({ message: i18n.t("errorMessages.invalidFollowUpDate") });
            }

            // VALIDATION: Check if next follow-up is prior to last follow-up.
            if (arNotes.last_follow_up_date) {
                const nextDate = new Date(arNotes.next_followup_date);
                const lastDate = new Date(arNotes.last_follow_up_date);

                // Clear time components for an accurate date-only comparison if needed
                nextDate.setHours(0, 0, 0, 0);
                lastDate.setHours(0, 0, 0, 0);

                if (nextDate < lastDate) {
                    return rejectWithValue({ 
                        message: i18n.t("errorMessages.nextFollowUpDateValidation") 
                    });
                }
            }

            let formData = {
                "notes": arNotes.notes,
                "next_follow_up_date": format(new Date(arNotes.next_followup_date), "yyyy-MM-dd"),
                "claim": payload,
                "category": 'ar_claim',
                "ar_status": arNotes.ar_status_code,
                "ar_action": arNotes.ar_action_code,
                "ar_note_template": arNotes.selected_template_id
            };

            // Determine action mode dynamically
            const isEditMode = Boolean(arNotes.id);

            // Await the API call directly based on mode
            const result = isEditMode
                ? await service.UpdateClaimNotes(arNotes.id, formData)
                : await service.AddArClaimNotes(formData);

            const message = isEditMode ? UPDATE_SUCCESS : ADD_SUCCESS;


            dispatch(ListArClaimNotes(claimPK));

            return { result, message };
        } catch (error) {
            return rejectWithValue({message:i18n.t("errorMessages.commonError")})
        }
    }
);


/**
 * API Call functionality to fetch ar-notess list.
 */
export const ListArClaimNotes = createAsyncThunk(
    "claimManagement/ListArClaimNotes",
    async (payload,{rejectWithValue,getState}) => {
        let {claimManagement}=getState();
        let {claim_pk} = claimManagement
        try {
            const response = await service.ListArClaimNotes(payload || claim_pk);
            return response.data.results
        } catch (error) {
            return rejectWithValue({ message: i18n.t("errorMessages.ar_notes_list_error")})
        }
    }
);

/**
 * API Call functionality to fetch individual ar-notes details.
 */
export const onEditArClaimNotes = createAsyncThunk(
    "claimManagement/onEditArClaimNotes",
    async (payload, thunkAPI) => {
        try {
            let response = await service.GetArClaimNotes(payload);
            return response.data
        } catch (error) {
            return thunkAPI.rejectWithValue({ message: i18n.t("errorMessages.ar_notes_list_error")})
        }
    }
);

/**
 * API Call functionality to delete individual ar-notes details.
 */
export const onDeleteArClaimNotes = createAsyncThunk(
    "claimManagement/onDeleteArClaimNotes",
    async (payload, {dispatch,rejectWithValue,getState}) => {
        let {claimManagement}=getState();
        let {claimPK} = claimManagement
        try {
            let response = await service.DeleteClaimNotes(payload);
            if (response.status == 204) {
                dispatch(ListArClaimNotes(claimPK));
                dispatch(resetArnotes())
            }
            return response.data
        } catch (error) {
            return rejectWithValue({ message: i18n.t("errorMessages.ar_notes_delete_error")})
        }
    }
);

/**
 * APi to get ar claims
 */
export const getCptCodesForClaim=createAsyncThunk(
    "arClaims/getCptCodesForClaim",
    async (payload, {rejectWithValue}) => {
        let {claim_id,index}=payload
        try {
            let response = await service.GetARClaimProcedureList(claim_id);
            return {data:response.data,index:index,id:claim_id};
        } catch (error) {
            return rejectWithValue({ message: 'Something went wrong' })
        }
    }
);

/**
 * APi to get ar claims
 */
export const getActivityOfProcedure=createAsyncThunk(
    "arClaims/getActivityOfProcedure",
    async (payload, {rejectWithValue}) => {
        let {id,index,main_index}=payload
        try {
            let response = await service.GetARClaimActivityOfProcedure(id);
            return {data:response.data,index:index,id:id,main_index:main_index};
        } catch (error) {
            return rejectWithValue({ message: 'Something went wrong' })
        }
    }
);

/**
 * Function getClaimModuleFilterDataSet fetches all the drop-down-data required for the claim filter in one shot using promise chaining 
 */
export const getClaimModuleFilterDataSet = createAsyncThunk(
    "claimManagement/getClaimModuleFilterDataSet",
    async (payload, thunkAPI) => {
        const pageSize = 0;
        const page = 0;
        const practicePK = getStorage('practice');

        const promises = [
            service1.getProvidersData(pageSize, page, practicePK, true).then(response => response.data),
            claim_service.ServiceLocationLists(practicePK, null, null, true).then(response => {
                let locations = []
                response.data.map((item) => {
                    item.id = item.Id + '||' + item.location_type
                    locations.push(item)
                })
                return locations
            }),
            claim_service.ListInsuranceNames(pageSize, 0, practicePK).then(response => response.data),
            claim_service.ListClaimStatus(pageSize, page, practicePK).then(response => response.data),
            claim_service.ListCPTCodes(practicePK).then(response => response.data),
            claim_service.ARStatusNoteList(0, 0, practicePK).then(response => {
                let data = []
                response.data.map((item) => {
                    data.push({
                        id: item.id,
                        name: item.name
                    })
                })
                return data
            }),
            claim_service.ARActionNoteList(0, 0, practicePK).then(response => {
                let data = []
                response.data.map((item) => {
                    data.push({
                        id: item.id,
                        name: item.name,
                        follow_up_days_count: item.follow_up_days_count
                    })
                })
                return data
            }),
            claim_service.ListPracticeUsers(practicePK).then(response => {
                let data = []
                response.data.map((item) => {
                    data.push({
                        id: item.id,
                        name: item.name
                    })
                })
                return data
            }),
        ];
        try {
            const [
                providerList,
                ServiceLocationList,
                payerList,
                claimStatusList,
                cptCodesList,
                arStatusList,
                arActionCodeList,
                practiceUsersList

            ] = await Promise.all(promises);

            return {
                providerList,
                ServiceLocationList,
                payerList,
                claimStatusList,
                cptCodesList,
                arStatusList,
                arActionCodeList,
                practiceUsersList
            };
        } catch (error) {
            return thunkAPI.rejectWithValue({ errorMessage: 'Error getting Drop-down list data!' })
        }
    }
);

export const searchClaimsWithAdvancedFilters = createAsyncThunk(
    'claims/searchClaimsWithAdvancedFilters',
    async ({ simpleFilters, advancedFilters, pagination = {}, sort = {}, patient_PK }, { rejectWithValue }) => {
        try {
            const practicePK = getStorage('practice');
            const queryParams = buildClaimsPayload({ simpleFilters, advancedFilters, practicePK, patient_PK });

            // Add pagination params
            if (pagination.pageSize) {
                queryParams.page_size = pagination.pageSize;
            }
            if (pagination.page) {
                queryParams.page = pagination.page;
            }

            // Add sort param using the system convention: &column={orderType}{sortField}
            // orderType is "" for ASC and "-" for DESC
            if (sort?.sortField) {
                queryParams.column = `${sort.orderType ?? ""}${sort.sortField}`;
            }

            // Builds query string without URLSearchParams to avoid encoding commas (%2C)
            // in multi-select values (e.g. assigned_user_pk=2,64,49)
            const queryString = Object.entries(queryParams)
                .filter(([, value]) => value !== null && value !== undefined && value !== "")
                .map(([key, value]) => `${key}=${value}`)
                .join('&');

            const response = await service.SearchClaimsV2(queryString);
            
            if (response?.status === 200) {
                return response.data;
            }
            
            return rejectWithValue({ 
                message: response?.data?.error_message || "An unexpected error occurred while searching claims."
            });
        } catch (error) {
            return rejectWithValue({ 
                message: error?.message || "Failed to search claims." 
            });
        }
    }
);


export const handleBulkStatusUpdate = createAsyncThunk(
    'claimManagement/handleBulkStatusUpdate',
    async (payload, { getState, rejectWithValue }) => {
        const { practicePK, patient_PK } = payload;
        const state = getState().claimManagement;

        try {
            // Build the dynamic payload matching the complete unified bulk update structural layout
            const claimData = buildClaimsPayload({
                simpleFilters: state.simpleSearchFilters,
                advancedFilters: state.advancedSearchClaimsFilterData,
                practicePK,
                patient_PK : patient_PK || null,
                mode: 'bulk', // Critical: tells the helper to output the bulk update schema
                selectionContext: {
                    selectAll: state.selectAll,
                    selectedClaimIDs: state.selectedClaimIDs,
                    unselectedClaimIDs: state.unselectedClaimIDs,
                    claimBulkStatusUpdate: state.claimBulkStatusUpdate,
                    responsibility_type: state.responsibility_type
                }
            });

            // API Call
            const response = await UpdateClaimStatusbulk(claimData);
            const {data} = response;
            if (data.status === 200) {
                return {
                    updateType: response.data?.update, // 'completed' or 'in-process'
                    message: response.data?.message,
                    referenceNumber: response.data?.reference_number
                };
            }

            if (data.code == 400 && data.message == "responsibility_type_invalid") {
                return rejectWithValue({ message: i18n.t("errorMessages.responsibility_invalid")});
            }

            // Fallback safety catch-all for structural error codes returned with 200 HTTP statuses
            return rejectWithValue({ message: data.message || i18n.t("errorMessages.commonError") });
            
            

        } catch (error) {
            const errorMsg = error.response?.data?.message === "responsibility_type_required"
                ? i18n.t('errorMessages.responsibility_required')
                : i18n.t("errorMessages.commonError");
            return rejectWithValue({ message: errorMsg });
        }
    }
);

export const arFollowupNotes =  createAsyncThunk(
    'claimManagement/arFollowupNotes',
    async(_, {rejectWithValue})=> {
        try {
            const response = await service.GetARNoteTemplates();
            return response.data; 
        } catch (error) {
            return rejectWithValue(
                error.response && error.response.data 
                    ? error.response.data 
                    : error.message
            );
        }
    }
)

// --- Generating HCFA ---
export const generateBulkHcfa = createAsyncThunk(
    'paperclaim/generateBulkHcfa',
    async ({ isWithHCFA, selectedClaimIDs, practicePK }, { rejectWithValue }) => {

        try {
            //  Validation Checks
            if (!selectedClaimIDs?.length) {
                return rejectWithValue({ type: 'error', message: i18n.t("commons.selectClaim") });
            }
            if (selectedClaimIDs.length > 20) {
                return rejectWithValue({ type: 'error', message: i18n.t("commons.maxlimitExceeded") });
            }

            let datas = {
                'claim_pks': selectedClaimIDs,
                'with_hcfa': isWithHCFA,
                'practice_id': Number(practicePK),
                'current_practice_id': Number(practicePK)
            };

            // API Request
            const response = await searchClaimService.GenerateHCFA(datas);
            const { status, data, headers } = response || {};
            // Success Handler (200 OK)
            if (status === 200) {
                const blob = new Blob([data], { type: "application/pdf" });
                const fileURL = URL.createObjectURL(blob);

                // Safely extract filename or fallback if content-disposition is missing
                const contentDisposition = headers?.['content-disposition'] || 'document.pdf';
                const pdfWindow = window.open("", "_blank");
                // const pdfWindow = window.open("", "_blank");
                if (!pdfWindow) {
                    // This will trigger the catch block below
                    throw new Error("Pop-up blocker detected");
                }

                // Redirect the already-opened window
                pdfWindow.location.href = `${fileURL}#filename=${contentDisposition}`;

                return { success: true };
            }

            // Handle specific API business errors
            if (data?.error_message === "max_allowed_entries_exceeds") {
                return rejectWithValue({ type: 'error', message: i18n.t("commons.maxEntryExceed") });
            }

            if (status === 400) {
                const translationKey = data?.message === "no_data_available_for_claim_form"
                    ? 'errorMessages.no_record_found_to_export'
                    : 'errorMessages.commonError';
                return rejectWithValue({ type: 'error', translationKey });
            }

            // Fallback for any other unhandled API status codes (e.g., 500, 403, 404)
            return rejectWithValue({ type: 'error', translationKey: 'commons.contactAdminError' });

        } catch (error) {
            // Handle client-side / runtime errors / network crashes
            if (error?.message?.includes("Pop-up blocker detected")) {
                return rejectWithValue({ type: 'error', message: i18n.t("commons.popupBlocker") });
            }

            console.error("Error while processing paper claim form:", error);
            return rejectWithValue({ type: 'error', translationKey: 'errorMessages.commonError' });
        }
    }
);


// ====================== BULK CLAIM ASSIGNMENT ======================
export const assignBulkClaims = createAsyncThunk(
    'claimManagement/assignBulkClaims',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await service.claimBulkAssign(payload);
            return response.data || response;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);
/**
 * Function getArClaimFilterDataSet fetches all the drop-down-data required for the claim filter in one shot using promise chaining 
 */
export const getArClaimFilterDataSet = createAsyncThunk(
    "claimbeta/getArClaimFilterDataSet",
    async (payload, thunkAPI) => {
        const practicePK = getStorage('practice');

        const promises = [
            claim_service.ARStatusNoteList(0, 0, practicePK).then(response => {
                let data = []
                response.data.map((item) => {
                    data.push({
                        id: item.id,
                        name: item.name
                    })
                })
                return data
            }),
            claim_service.ARActionNoteList(0, 0, practicePK).then(response => {
                let data = []
                response.data.map((item) => {
                    data.push({
                        id: item.id,
                        name: item.name
                    })
                })
                return data
            })
        ];
        try {
            const [
                arStatusList,
                arActionCodeList,

            ] = await Promise.all(promises);

            return {
                arStatusList,
                arActionCodeList,
            };
        } catch (error) {
            return thunkAPI.rejectWithValue({ errorMessage: i18n.t("errorMessages.error_drowdown_list_data") })
        }
    }
);
